import React from "react";
import { iconProps } from "../Helper";

const  ArrowUpFillIcon=({className}:iconProps)=> {

  return (
    <svg
      width="10"
      height="5"
      viewBox="0 0 10 5"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path className={className} d="M5 0L10 5L0 5L5 0Z" fill="white" />
    </svg>
  );
}

export default ArrowUpFillIcon;
